console.log('[TIMING] myjs.js STARTED LOADING at:', performance.now().toFixed(0) + 'ms');
	let order_id = Math.random().toString(36).slice(2);
const proxy_loc = "https://luxcanva.karangoyal.cc/";
// const proxy_loc = window.location.origin;
var preview_thumb_upload = 'https://cdn.shopify.com/s/files/1/0511/8522/1811/files/download_9.png'
var image_upload_file = preview_thumb_upload;

var qr_url = '';

var map_color_present = '';

var cart_order_id_present = []
var cart_order_id_present_id = []

var star_map_color_or = '#000000'

// Load star map function - call IMMEDIATELY, don't wait for document.ready
function loadStarMap() {
    console.log('[TIMING] loadStarMap() called at:', performance.now().toFixed(0) + 'ms');
    Celestial.display({
        width: 1080,
        projection: "airy",
        transform: "equatorial",
        center: null,
        geopos: null,
        follow: "zenith",
        orientationfixed: true,
        zoomlevel: null,
        zoomextend: 10,
        adaptable: true,
        interactive: false,
        disableAnimations: true,
        location: false,
        formFields: { location: true, general: true, stars: true, dsos: true, constellations: true, lines: true, other: true, download: true },
        advanced: true,
        daterange: [],
        settimezone: true,
        controls: false,
        lang: "",
        culture: "",
        container: "celestial-map",
        stars: {
            show: true, limit: 6, colors: false,
            style: { fill: "#ffffff", opacity: 1 },
            designation: false, designationType: "desig",
            designationStyle: { fill: "#ddddbb", font: "11px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif", align: "left", baseline: "top" },
            designationLimit: 2.5,
            propername: false, propernameType: "name",
            propernameStyle: { fill: "#ddddbb", font: "0px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif", align: "right", baseline: "bottom" },
            propernameLimit: 1.5, size: 12, exponent: -.29, data: "stars.6.json"
        },
        dsos: { show: false, limit: 6, colors: true, style: { fill: "#cccccc", stroke: "#cccccc", width: 2, opacity: 1 }, names: true, namesType: "desig", nameStyle: { fill: "#cccccc", font: "11px 'Lucida Sans Unicode', 'DejaVu Sans', Helvetica, Arial, serif", align: "left", baseline: "bottom" }, nameLimit: 4, size: null, exponent: 1.4, data: "dsos.bright.json", symbols: { gg: { shape: "circle", fill: "#ff0000" }, g: { shape: "ellipse", fill: "#ff0000" }, s: { shape: "ellipse", fill: "#ff0000" }, s0: { shape: "ellipse", fill: "#ff0000" }, sd: { shape: "ellipse", fill: "#ff0000" }, e: { shape: "ellipse", fill: "#ff0000" }, i: { shape: "ellipse", fill: "#ff0000" }, oc: { shape: "circle", fill: "#ff9900", stroke: "#ff9900", width: 2 }, gc: { shape: "circle", fill: "#ff9900" }, en: { shape: "square", fill: "#ff00cc" }, bn: { shape: "square", fill: "#ff00cc" }, sfr: { shape: "square", fill: "#cc00ff" }, rn: { shape: "square", fill: "#0000ff" }, pn: { shape: "diamond", fill: "#00cccc" }, snr: { shape: "diamond", fill: "#ff00cc" }, dn: { shape: "square", fill: "#999999", stroke: "#999999", width: 2 }, pos: { shape: "marker", fill: "#cccccc", stroke: "#cccccc", width: 1.5 } } },
        constellations: { show: true, names: false, namesType: "iau", nameStyle: { fill: "#ffffff", align: "center", baseline: "middle", opacity: .8, font: ["20px Open Sans, Arial, sans-serif", "15px Open Sans, Arial, sans-serif", "15px Open Sans, Arial, sans-serif"] }, lineStyle: { stroke: "#cccccc", width: 1, opacity: 0.75 }, lines: true, bounds: false, boundStyle: { stroke: "#ccff00", width: 2, opacity: .8, dash: [2, 6] } },
        mw: { show: false, style: { fill: "#ffffff", opacity: "0.15" } },
        lines: { graticule: { show: false, stroke: "#949494", width: 2.8, opacity: .7, lon: { pos: [], fill: "#eee", font: "10px 'Lucida Sans Unicode', Helvetica, Arial, sans-serif" }, lat: { pos: [], fill: "#eee", font: "10px 'Lucida Sans Unicode', Helvetica, Arial, sans-serif" } }, equatorial: { show: false, stroke: "#aaaaaa", width: 1.3, opacity: .7 }, ecliptic: { show: false, stroke: "#66cc66", width: 1.3, opacity: .7 }, galactic: { show: false, stroke: "#cc6666", width: 1.3, opacity: .7 }, supergalactic: { show: false, stroke: "#cc66cc", width: 1.3, opacity: .7 } },
        horizon: { show: false, stroke: "#cccccc", width: 1, fill: "#000000", opacity: .4 },
        daylight: { show: false },
        planets: { show: true, which: ["ter", "lun"], symbols: { sol: { symbol: "\u2609", letter: "Su", fill: "#ffff00", size: 12 }, mer: { symbol: "\u263F", letter: "Me", fill: "#cccccc" }, ven: { symbol: "\u2640", letter: "V", fill: "#eeeecc" }, ter: { symbol: "\u2295", letter: "T", fill: "#00ccff" }, lun: { symbol: "\u25CF", letter: "L", fill: "#ffffff", size: 40 }, mar: { symbol: "\u2642", letter: "Ma", fill: "#ff6600" }, cer: { symbol: "\u26B3", letter: "C", fill: "#cccccc" }, ves: { symbol: "\u26B6", letter: "Ma", fill: "#cccccc" }, jup: { symbol: "\u2643", letter: "J", fill: "#ffaa33" }, sat: { symbol: "\u2644", letter: "Sa", fill: "#ffdd66" }, ura: { symbol: "\u2645", letter: "U", fill: "#66ccff" }, nep: { symbol: "\u2646", letter: "N", fill: "#6666ff" }, plu: { symbol: "\u2647", letter: "P", fill: "#aaaaaa" }, eri: { symbol: "\u26AA", letter: "E", fill: "#eeeeee" } }, symbolStyle: { fill: "#cccccc", opacity: 1, font: "bold 17px 'DejaVu Sans Mono', 'Arial Unicode MS', sans-serif", align: "center", baseline: "middle" }, symbolType: "symbol", names: false, nameStyle: { fill: "#cccccc", font: "14px 'Lucida Sans Unicode', 'DejaVu Sans', sans-serif", align: "right", baseline: "top" }, namesType: "en" },
        form: false,
        datapath: "https://luxcanva.karangoyal.cc/static/celestial-data/",
        timezoneid: "OZJZSV28I4V8",
        background: { fill: "#000000", opacity: 1, stroke: "#ffffff", width: 2 }
    });

    // Enable animations after initial load
    setTimeout(function(){
        changeBackgroundColor();
        Celestial.apply({disableAnimations: false});
    }, 1500);
}

// CRITICAL: Call loadStarMap IMMEDIATELY - don't wait for document.ready
// Scripts are at end of body so #celestial-map container already exists
console.log('[TIMING] Calling loadStarMap() IMMEDIATELY at:', performance.now().toFixed(0) + 'ms');
loadStarMap();

$(document).ready(function(){
console.log('[TIMING] document.ready FIRED at:', performance.now().toFixed(0) + 'ms');
$('#cover-spin').hide();
  addInspiration()

//   fetch('/' + 'cart.js')
// .then(response => {
//   return response.json();
// }).then(response => {
//   $('.grid__picker.style_picker .elem__picker').eq(0).click()
//   console.log(response);
//   $('div#print').css('min-height', $('.custom-frame').outerHeight()+20+'px')
//   response.items.forEach(x=>{
//       cart_order_id_present.push(x.properties.OrderID)
//       cart_order_id_present_id.push(x.key)
//   })
// })
// .catch((error) => {
//   console.error('Error:', error);
// });
  
  $("input[name='categories']").on('change', function(){
	addInspiration()	
  })
  
  function addInspiration() {
        if ($("input[name='categories']:checked").val()) {
            var a = $("input[name='categories']:checked").val();
            var e = [];
            for ($('.modal-body').empty(),
            k = 0; k < inspiration[a].length; k++)
                e.push(inspiration[a][k]);
            for (i = 0; i < e.length; i++)
                $('.modal-body').append("<a class='list-group-item list-group-item-action saying-item' data-toggle='list' role='tab' aria-controls='home'><p class='text-center mb-0 pre'><small>" + e[i].replace(/(?:\r\n|\r|\n)/g, "<br>") + "</small></p></a>")
        }
    }

$(document).on('click','.saying-item', function(){
  $(".saying-item.active").removeClass('active');
  $(this).addClass('active')
})

  $(document).on('click','label.btn.btn-modal', function(){
  $("label.btn.btn-modal.active").removeClass('active');
  $(this).addClass('active')
})

$('.open_ins_modal').on('click', function(){
  $('.modal-backdrop.fade').show().addClass('show')
  $("#exampleModalCenter").fadeIn('800', function(){
    $(this).addClass('show')
  })
})  

  function closeModal(){
    $("#exampleModalCenter").fadeOut('800', function(){
    $(this).removeClass('show');
    $('.modal-backdrop.fade').removeClass('show').hide()
  })
  }

  $(document).on('click','.modal-content button.close, .modal-backdrop', function(){closeModal()})

$(document).on("click", "#confirmSaying", function() {
  closeModal()
  var a = $(".saying-item.active");
  if (a.length > 0) {
    var i = a.children().children().html().replace(/<br\s*\/?>/gi, "\n").replace("&amp;", "&");
    document.getElementById('textMessage').value = i;
    setTimeout(function(){
      var value = document.getElementById("textMessage").value.replace(/\r\n|\r|\n/g,"<br />");
      $('.custom-textarea').html(value);
      twemoji.parse(document.getElementsByClassName('custom-textarea')[0],
        { base: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/' });
    }, 200);
  }
})

    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
      let value_order = params.order_id;

      if(value_order){
        (async () => {
            const rawResponse = await fetch(proxy_loc+'star-map-data/?order_no='+value_order, {
              method: 'GET'
            });
            const content = await rawResponse.json();

            order_id = content.order
          
            console.log(content);
            $('.grid__picker.style_picker .elem__picker').each(function(){
                if($(this).text().trim() == content.model){
                  $(this).click()
                }
            })

            $('input#address_form1').val(content.location)
			$('#custom_address').val(content.address)
            $('span#custom_add').html(content.address)

            let only_date = content.date,
            date = only_date.split(' ')[0],
            month = only_date.split(' ')[1],
            year = only_date.split(' ')[2];

            let only_time = content.time,
            hrs = only_time.split(' ')[0],
            mins = only_time.split(' ')[1],
            am_pm = only_time.split(' ')[2];

            $('.bear-dates').val(date)
            $('.bear-months').val(month)
            $('.bear-years').val(year)

            $('.hours-dropdown').val(hrs)
            $('.minutes-dropdown').val(mins)
            $('label[for="timePickerMeridian'+am_pm+'"]').click()

            $('#custom_lat_input input').val(content.lat.split(' ')[0])

            $('#custom_lat_input select').val(content.lat.split(' ')[1])

            $('#custom_lng_input input').val(content.long.split(' ')[0])

            $('#custom_lng_input select').val(content.long.split(' ')[1])

             $('.bear-years').val(year).trigger('change')

            if(!content.custom_image_url.includes(preview_thumb_upload)){
                $('#image_code').click()
                $('#bg-img-new').prop('src', content.custom_image_url)
            }

			if(content.border){
				$('.grid__picker.custom_border .elem__picker').eq(1).click()
			}

            if(content.qr_text){
                $('#qrCodeSlide').click()
                $('#qr-input').val(content.qr_text).trigger('change')
                $('#qrcode').html('<img src="'+content.qr_url+'" />')
            }

			if(content.shape){
				$('[data-shape="'+content.shape+'"]').click()
			}

            $('#textTitle').val(content.title)
            $('#skyMap').html(content.title)

            // $('#textMessage').val(content.message.replaceAll('<br>', "\n")).trigger('keydown')
            // $('.custom-textarea').html(content.message)
            // let s = content.message
            var s = ''+content.message;
            var htmlObject = document.createElement('div');
            htmlObject.innerHTML = s;

            $('.custom-textarea').html(htmlObject.innerHTML)
            // var i = htmlObject.innerHTML.replace(/<br\s*\/?>/gi, "\n").replace("&amp;", "&");
            console.log(content.message_preview)
			document.querySelector('textarea#textMessage').value = content.message_preview
            $('textarea#textMessage').trigger('input')
            $('textarea#textMessage').trigger('keydown')

			$('#mat-input-7').val(content.date_time)

			$('#custom_lat_long').val(content.coordinates).trigger('keyup')

			var elements = content.star_map_elements.split(','),
			constellation = elements[0].split(':')[1] == "true"?console.log('Already checked'):$('.celestialConstellation').click(),
			graticule = elements[1].split(':')[1] == "true"?$('.celestialGrid').click():console.log('Already checked'),
			milkyway = elements[2].split(':')[1] == "true"?$('.celestialMilkyWay').click():console.log('Already checked'),
			moon = elements[3].split(':')[1] == "true"?console.log('Already checked'):$('.celestialMoon').click(),
			constellationname= elements[4].split(':')[1] == "true"?$('.celestialConstellationNames').click():console.log('Already checked');
			map_color_present = content.background_color;

			document.querySelectorAll('.grid__picker.font_change_message .elem__picker p').forEach((x)=>{
			var rr = getComputedStyle(x).getPropertyValue("font-family");
				if(rr == content.message_font){
					x.click()
				}
			})
			
			document.querySelectorAll('.grid__picker.font_change_details .elem__picker p').forEach((x)=>{
			var rr = getComputedStyle(x).getPropertyValue("font-family");
				if(rr == content.details_font){
					x.click()
				}
			})

			

			$('input.input-email').val(content.email)
			setTimeout(()=>{
				$('.custom-frame.bg-new.shadow.text-center.p-3').css('background-color', content.background_color)

				lightOrDark(content.background_color, 'background') == 'dark'?changeTextToDarkColor(content.background_color):changeTextToLightColor(content.background_color)

				if(content.bg_image_url){
					$('.custom-frame.bg-new.shadow.text-center.p-3').css('background-image', 'url('+content.bg_image_url+')')
				}

				if($('#bg-img-new').prop('src') == window.location.href.replaceAll('#','')){
					$('#bg-img-new').hide()
				}

				changeBackgroundColor(content.background_color)
				
				console.log(lightOrDark(content.star_map_color, 'map'))
				$('#background-fill').val(content.star_map_color)
				trigger_change_event("background-fill");
				setTimeout(()=>{
					Celestial.location([content.lat.includes('N')? content.lat.replaceAll(' N','').replaceAll(' S',''):parseFloat(content.lat.replaceAll(' N','').replaceAll(' S',''))*-1, content.long.includes('E')? content.long.replaceAll(' E','').replaceAll(' W',''):parseFloat(content.long.replaceAll(' W','').replaceAll(' E',''))*-1])
				},2500)
			}, 1000)
          })();
      }

    $(".Click-here").on('click', function() {
        $(".custom-model-main").addClass('model-open');
    }); 

    $(".close-btn, .bg-overlay").click(function(){
        $(".custom-model-main").removeClass('model-open');
    });



	// Initialize S3 Direct Upload (replaces UploadCare)
	// The S3DirectUploader class is defined in s3-direct-uploader.js
	let circularImageUploader;
	let backgroundImageUploader;

	// Function to initialize uploaders
	function initializeS3Uploaders() {
		// Check if S3DirectUploader class is available
		if (typeof S3DirectUploader === 'undefined') {
			console.error('S3DirectUploader class not found. Make sure s3-direct-uploader.js is loaded.');
			return;
		}

		// Check if input elements exist
		const imgInput = document.getElementById('my-img-input');
		const bgInput = document.getElementById('my-bg-input');

		if (!imgInput || !bgInput) {
			console.warn('Upload input elements not found yet, retrying...');
			setTimeout(initializeS3Uploaders, 200);
			return;
		}

		// Initialize circular image uploader (1:1 aspect ratio)
		circularImageUploader = new S3DirectUploader('my-img-input', 'bg-img-new', '1:1');

		// Initialize background image uploader (3:4 aspect ratio)
		backgroundImageUploader = new S3DirectUploader('my-bg-input', 'custom-frame-bg', '3:4');

		console.log('✓ S3 uploaders initialized successfully');
	}

	// Initialize when DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initializeS3Uploaders);
	} else {
		// DOM already loaded
		setTimeout(initializeS3Uploaders, 100);
	}

	// Pure JS replacement for dateAndTime plugin
	document.querySelectorAll('.time__picker').forEach(function(element) {
		if (element.getAttribute('done') === 'true') return;

		var className = element.className;
		var valueParts = (element.value || '').split(' ');
		var date = valueParts[0] || '';
		var time = valueParts[1] || '00:00';

		// Create date input
		var dateInput = document.createElement('input');
		dateInput.type = 'date';
		dateInput.value = date;
		dateInput.className = className;

		// Create time input
		var timeInput = document.createElement('input');
		timeInput.type = 'time';
		timeInput.value = time;
		timeInput.className = className;

		// Insert before original and hide original
		element.parentNode.insertBefore(dateInput, element);
		element.parentNode.insertBefore(timeInput, element);
		element.setAttribute('done', 'true');
		element.style.display = 'none';
		element.classList.remove(className.split(' ')[0]);

		// Update hidden input on change
		function updateValue() {
			element.value = dateInput.value + ' ' + timeInput.value;
			element.setAttribute('value', element.value);
		}
		dateInput.addEventListener('change', updateValue);
		timeInput.addEventListener('change', updateValue);
	});

	$('.switcher__wrapper .switch input').on("change" ,function(e){
		if ($(this).prop('checked') == true) {
			$(this).closest('.switcher__wrapper').find('.row__input--main').removeClass("disabled__row");
		} else{
			$(this).closest('.switcher__wrapper').find('.row__input--main').addClass("disabled__row");
		}
	});



	$(".head__settings").on("click" ,function(e){
		e.preventDefault();
		var currentIndex = $(this).closest('.element__settings').index();
		$(".element__settings").each(function(index,elem){
			if (index != currentIndex) {
				$(elem).removeClass("active__settings");
				$(elem).find('.content__settings').slideUp(250);
			}
		});
		$(this).closest(".element__settings").toggleClass("active__settings");
		if ($(this).closest(".element__settings").hasClass("active__settings")) {
			$(".mobile__menu ul li").removeClass("active__mobile");
			$(".mobile__menu ul li").eq($(".active__settings").index()).addClass("active__mobile");
		}
		$(this).closest(".element__settings").find(".content__settings").slideToggle(250);
		$(".image__circle").each(function(index,elem){
			$(this).css("height" ,$(this).outerWidth()+'px');
		});
		if ($(this).closest(".element__settings").hasClass("active__settings")) {
			$(this).closest(".element__settings").addClass("visited");
		}
	});
	$(".elem__picker").on("click" ,function(e){
		//e.preventDefault();
		if (!$(this).closest(".grid__picker").hasClass("multiple__picker")) {
			$(this).closest(".grid__picker").find(".elem__picker").removeClass("active__picker");
			$(this).addClass('active__picker');
            console.log($(this).attr("data-state"))
			if ($(this).hasClass("elem__state")) {
                $('.add__cart--price p').show();
				$(".state__picker[data-state="+ $(this).attr("data-state") +"]").fadeIn(250);
				$(".image__circle").each(function(index,elem){
					$(this).css("height" ,$(this).outerWidth()+'px');
				});
                $(".state__picker.state_2[data-state="+ $(this).attr("data-state") +"] .elem__picker").eq(0).click()
                $(".state__picker.state_3[data-state="+ $(this).attr("data-state") +"] .elem__picker").eq(0).click()
                if($(this).attr("data-state").includes('Canvas') || $(this).attr("data-state").includes('Digital')){
                  $('.picker__wrapper.state__picker.state_3').hide();
                }else{
                  $(".state__picker.state_3[data-state="+ $(this).attr("data-state") +"]").show();
                }
			}
			$(this).closest(".grid__picker").find(".elem__picker").each(function(index,elem){
				if ($(elem).hasClass("elem__state")) {
					if (!$(elem).hasClass("active__picker")) {
						$(".state__picker[data-state="+ $(elem).attr("data-state") +"]").css("display" ,"none");
					}
				}
			});

          console.log($(this).parent())

          if($(this).hasClass("state_1")){
            $('.single-option-selector option[value="'+$(".state_1.active__picker .info__picker p").text().trim()+'"]').prop('selected', true).trigger('change')
          }

          if($(this).parent().parent().hasClass("state_2")){
            $('.single-option-selector option[value="'+$(".state__picker.state_2[data-state='"+$('.state_1.active__picker').data("state")+"'] .active__picker .info__picker p").text().trim()+'"]').prop('selected', true).trigger('change')
          }

          if($(this).parent().parent().hasClass("state_3")){
            $('.single-option-selector option[value="'+$(".state__picker.state_3[data-state='"+$('.state_1.active__picker').data("state")+"'] .active__picker .info__picker p").text().trim()+'"]').prop('selected', true).trigger('change')
          }
		} else {
			$(this).toggleClass("active__picker");
		}
	});

	$(".image__circle").each(function(index,elem){
		$(this).css("height" ,$(this).outerWidth()+'px');
	});

	$(window).on("resize" ,function(){

      
    // Store the window width
    var windowWidth = $(window).width();

    // Resize Event
    $(window).resize(function(){

        // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
        if ($(window).width() != windowWidth) {

            // Update the window width for next time
            windowWidth = $(window).width();

            // Do stuff here

          $(".image__circle").each(function(index,elem){
			$(this).css("height" ,$(this).outerWidth()+'px');
		});
		if ($(window).width() < 991 && $(".visited").length != $(".element__settings").length) {
			$(".next__step").css("display" , "inline-flex");
			$('.submit__form').css("display" , "none");
		}
		if ($(window).width() > 991 && $(".element__settings").length) {
			$('.element__settings').css('display' , "block");
		}
		if ($(window).width() < 991 && $(".element__settings").length) {
			$('.element__settings').css("display" , "none");
			$('.element__settings.active__settings').css("display" ,"block");
		}
		if ($(window).width() < 991 && $('.active__settings').length == 0){
			$('.active__mobile').removeClass("active__mobile");
		}

        }

        // Otherwise do nothing

    });
      console.log('Resized')
		

		$('div#print').css('min-height', $('.custom-frame').outerHeight()+20+'px')

	});
	if ($(window).width() < 991 && $(".visited").length != $(".element__settings").length) {
		$(".next__step").css("display" , "inline-flex");
		$('.submit__form').css("display" , "none");
	}

	$(".mobile__menu ul li a").on("click" ,function(e){
		e.preventDefault();
      console.log('Li a clicked')
		$(".mobile__menu ul li").removeClass("active__mobile");
		$(this).closest("li").addClass("active__mobile");
		$(".element__settings").css("display" , "none");
		$(".element__settings").removeClass("active__settings");
		$(".content__settings").css("display" , "none");
		$(".element__settings").eq($(this).closest('li').index()).find(".content__settings").fadeIn(300);
		$(".element__settings").eq($(this).closest('li').index()).addClass("active__settings");
		$(".element__settings").eq($(this).closest('li').index()).addClass("visited");
		$(".element__settings").eq($(this).closest('li').index()).fadeIn(250);
		$(".image__circle").each(function(index,elem){
			$(this).css("height" ,$(this).outerWidth()+'px');
		});
		if ($(this).closest('li').index() == $(".mobile__menu ul  li").length  - 1) {
			$(".next__step").css("display" , "none");
			$('.submit__form').css("display" , "inline-flex");
		} else {
			$(".next__step").css("display" , "inline-flex");
			$('.submit__form').css("display" , "none");
		}
	});
	$(".next__step").on("click" ,function(e){
		e.preventDefault();
console.log('next step a clicked')
		$(".mobile__menu ul li.active__mobile").removeClass("active__mobile")
																					 .next().addClass("active__mobile");
		$(".element__settings").css("display" , 'none');																			 
        $(".element__settings").eq($(".active__mobile").index()).fadeIn(250);
        if (!$('.active__mobile').next().length) {
        	$(".next__step").css("display" , "none");
			$('.submit__form').css("display" , "inline-flex");
        }
	});

    // Star map loaded via loadStarMap() at top of document.ready

});



// Old Celestial config removed - now in loadStarMap() function at top of file



var charactersPerLine=60;
var maxLines=5;
var textOutput="";
var onPaste=false;

function formatTextAsRequired() {
	/*
	This function handles two aspects:
	1. (a) READ VALUE from the textarea, (b) DETECT IF TEXT PER LINE IS TOO LONG  as required by the length restrictions, (c) PUSH OVERFLOWING TEXT from a line to the next line and (d) WRITE VALUE back to the textarea.
	2. (a) READ THE CURSOR POSITION to store the cursor position, and (b) POSITION THE CURSOR where a user would expect it after WRITE DATA.
	*/
	var textInput=document.getElementById("textMessage").value;//1a: READ VALUE
	var inputAsRows=textInput.split("\n");// create array from input => each element contains one row of the textarea
	var inputAsOneLine=textInput.replace(/(\r\n\t|\n|\r\t)/gm,"");//remove all line-breaks
	var cursorPositionOnInput=document.getElementById("textMessage").selectionStart;//2a: READ CURSOR POSITION
	var cursorOffsetAfterOutput=0;//set default value for cursor offset. cursor offset is needed when re-posiotioning the cursor after WRITE DATA
  
	var visibleCharactersPerLine=Math.floor((document.getElementById("textMessage").offsetWidth)/9);//number of visible characters per line before text breaks without a line-break. Depends on width of textarea and width of characters entered.
	var additionalTextAreaRows=0; //additional rows needed due to the text breaking
	
	var totalRows=inputAsRows.length; //don't put inputAsRows.length in the for statement, as the array is growing in the loop which results in an infinite loop
	var row;
	var lineBreakCount=0;
	var characterCount=0;
	for (row = 0; row < totalRows; ++row) {
	  if(inputAsRows[row].length>charactersPerLine){ //1b DETECT IF TEXT PER LINE IS TOO LONG 
		if (inputAsRows[row+1] === undefined) {
		  inputAsRows[row+1]="";// the row did not exist
		  totalRows++;
		  }
		//1c PUSH OVERFLOWING TEXT: move text that is too long for this row to the next row:
		inputAsRows[row+1]=inputAsRows[row].substring(charactersPerLine)+inputAsRows[row+1];
		inputAsRows[row]=inputAsRows[row].substring(0,charactersPerLine);
		//determine, if cursor was at the end of the line that got a line-break:
		var newOutput=inputAsRows.join("\n");
		if(newOutput.substr(cursorPositionOnInput-1,1)=="\n"){
		  cursorOffsetAfterOutput=1; }
		}
	  if(inputAsRows[row].length>visibleCharactersPerLine){ //1b DETECT IF TEXT PER LINE IS TOO LONG 
		additionalTextAreaRows=additionalTextAreaRows+Math.floor(inputAsRows[row].length/visibleCharactersPerLine);
		}
	  
	  }
  
	if(inputAsRows.length<=maxLines && inputAsOneLine.length<=(maxLines*charactersPerLine)){//data is within max number of rows and max total digits
	  textOutput=inputAsRows.join("\n");
	  document.getElementById("textMessage").rows=inputAsRows.length+additionalTextAreaRows;//resize textarea
	  if(onPaste){
		cursorOffsetAfterOutput=cursorOffsetOnPaste(textInput,cursorPositionOnInput,totalRows)
		}
	  }
	  else //data would be too long
	  {
	  cursorOffsetAfterOutput=-1;
	  // Still update textOutput so the display updates even if text exceeds limits
	  textOutput=inputAsRows.join("\n");
	  document.getElementById("textMessage").rows=Math.min(inputAsRows.length, maxLines)+additionalTextAreaRows;
	}
	document.getElementById("textMessage").value=textOutput;//1d: WRITE VALUE
	document.getElementById("textMessage").selectionStart=cursorPositionOnInput+cursorOffsetAfterOutput; //2b: POSITION CURSOR
	document.getElementById("textMessage").selectionEnd=cursorPositionOnInput+cursorOffsetAfterOutput; //set a single cursor, not a selection
	onPaste=false;
	
	 var value = document.getElementById("textMessage").value.replace(/\r\n|\r|\n/g,"<br />")
	$('.custom-textarea').html(value)
	twemoji.parse(document.getElementsByClassName('custom-textarea')[0],
	{ base: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/' })
	// localStorage.setItem("save_mssg", document.getElementById("textMessage").value);
	// localStorage.setItem("save_mssg_1", $('.custom-textarea').html());
  }

  function trigger_change_event(element_id){
	element = document.getElementById(element_id);
	  var event = new Event('change');
	  element.dispatchEvent(event);
  }
  
  function change_constellations()
  {
	var showConst = $(".celestialConstellation").hasClass('active__picker')
	document.getElementById("constellations-lines").checked = showConst;
	trigger_change_event("constellations-lines")
	//setCookie('save_consti',showConst, 7);
  
  }
  
  function change_constellations_names(){
	var showConstNames = $(".celestialConstellationNames").hasClass('active__picker')
	document.getElementById("constellations-names").checked = showConstNames;
	trigger_change_event("constellations-names");
	//setCookie('save_constiN',showConstNames, 7);
  }
  
  function show_grid()
  {
	var showGrid = $(".celestialGrid").hasClass('active__picker')
	document.getElementById("lines-graticule-show").checked = showGrid;
	trigger_change_event("lines-graticule-show");
	//setCookie('save_grid',showGrid, 7);
  }
  
  function show_milkyway()
  {
	var showMoon = $(".celestialMilkyWay").hasClass('active__picker')
	document.getElementById("mw-show").checked = showMoon;
	trigger_change_event("mw-show");
	//setCookie('save_milky',showMoon, 7);
  }
  
  function show_moon()
  {
	var showMoon = $(".celestialMoon").hasClass('active__picker')
	document.getElementById("planets-show").checked = showMoon;
	trigger_change_event("planets-show");
	//setCookie('save_moon',showMoon, 7);
  }
  

  function checkElementsChange(){
	change_constellations()
	change_constellations_names()
	show_grid()
	show_milkyway()
	show_moon()
  }

  function change_style(){
    var style = $('.style_picker .active__picker').index();
	console.log('Style Changed: '+style)
	if(style == 0){
        $('[data-state="Tablou__picker"]').click()
        $('.state_1, .final__step [data-state="'+$('.state_1.active__picker').data('state')+'"]').show()
        $('.hide-on-star').show()
		$('.hide_on_bg, .custom_iframe').show()
		$('.show_on_bg, [data-state="Sky_Light__picker"]').hide()
		$('.custom-frame').css('background-image', 'none')
        $('.custom-frame.bg-new.shadow.text-center.p-3').removeClass('skylight')
        $('.app__main').css('background-color', 'rgba(0,0,0,0)')
		changeBackgroundColor()
	}else if(style == 1){
        $('[data-state="Tablou__picker"]').click()
        $('.final__step [data-state="'+$('.state_1.active__picker').data('state')+'"], .state_1').show()
        $('.hide-on-star').show()
		$('.hide_on_bg, .custom_iframe, [data-state="Sky_Light__picker"]').hide()
		$('.show_on_bg').show()
		$('.pt-2.pb-1.frame-container.pl-0.pr-0').css('color', '#ffffff')
        $('.custom-frame.bg-new.shadow.text-center.p-3').removeClass('skylight')
        $('.app__main').css('background-color', 'rgba(0,0,0,0)')
		change_background_image()
	}else  if(style == 2){
        $('[data-state="Sky_Light__picker"]').click()
        $('.final__step [data-state]').hide()
        $('.state_2[data-state="Sky_Light__picker"]').show()
        $('[data-shape="1"]').click()
        $('.bg_map_color_change [data-color="#010203"]').click()
        $('.custom_border .elem__picker').eq(0).click()
        $('input#qr-input').val('').trigger('change')
        $('.star_map_color_change [data-color="#010203"]').click()
		$('.hide_on_bg, .custom_iframe').show()
		$('.show_on_bg, .hide_on_bg, .hide-on-star').hide()
		$('.custom-frame').css('background-image', 'none')
        $('.custom-frame.bg-new.shadow.text-center.p-3').addClass('skylight')
        $('.app__main').css('background-color', '#000')
	}
	
}  

function change_background_image(){
	var src = $('.show_on_bg .active__picker img').eq(0).prop('src')
	$('.custom-frame').css('background-image', 'url("'+src+'")')
	$('.custom_border .elem__picker').eq(0).click()
	$('.shape_change_1 .elem__picker').eq(0).click()
	$('.bg_color_change .elem__picker').eq(0).click()	
	$('.bg_map_color_change .elem__picker').eq(0).click()
}

function change_font_message(){
	var font = $('.font_change_message .active__picker > .image__circle > p').css('font-family')
	$('.custom-textarea').css('font-family', font)
}

function change_font_details(){
	var font = $('.font_change_details .active__picker > .image__circle > p').css('font-family')
	$('.custom-address').css('font-family', font)
}


       
  function show_border(luminent){
    var showBorder = $('.custom_border .active__picker').index();
    var luminent = lightOrDark($('.custom-frame').css('background-color'), 'border')
	if(showBorder){
		if(luminent == 'light'){
			$(".pt-2.pb-1.frame-container").css('border','2px solid #000') ;
		}else{
			$(".pt-2.pb-1.frame-container").css('border','2px solid #fff') ;
		}
	}else{
		$(".pt-2.pb-1.frame-container").css('border','none') ;
	}
}  


  function changeStarMapColor(){
    if($('.star_map_color_change .elem__picker.active__picker').hasClass('custom_color_picker')){
        var map_color = $('.star_map_color_change .elem__picker #html5colorpickerstarmap').val()
    }else{
        var map_color = $('.grid__picker.star_map_color_change .elem__picker.active__picker .image__circle.image__color').data('color')
    }

    console.log(lightOrDark(map_color, 'map'))
    $('#background-fill').val(map_color)
    trigger_change_event("background-fill");
  }

  function changeStarAndConstellationToLightColor(){
    var config = {
            "stars": {
                "show": true,
                "limit": 6,
                "colors": false,
                "style": {
                    "fill": "#28282B",
                    "opacity": 1
                },
                "designation": false,
                "designationType": "desig",
                "designationStyle": {
                    "fill": "#28282B",
                    "font": "11px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif",
                    "align": "left",
                    "baseline": "top"
                },
                "designationLimit": 2.5,
                "propername": false,
                "propernameType": "name",
                "propernameStyle": {
                    "fill": "#28282B",
                    "font": "0px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif",
                    "align": "right",
                    "baseline": "bottom"
                },
                "propernameLimit": 1.5,
                "size": 12,
                "exponent": -0.29,
                "data": "stars.6.json"
            },
            "constellations": {
                "show": $('.celestialConstellation').hasClass('active__picker'),
                "names": $('.celestialConstellationNames').hasClass('active__picker'),
                "nameStyle": {
                    "fill": "#28282B",
                    "align": "center",
                    "baseline": "middle",
                    "opacity": 0.8,
                    "font": [
                        "20px Open Sans, Arial, sans-serif",
                        "15px Open Sans, Arial, sans-serif",
                        "15px Open Sans, Arial, sans-serif"
                    ]
                },
                "lineStyle": {
                    "stroke": "#28282B",
                    "width": 1,
                    "opacity": 0.75
                },
                "lines": true,
                "bounds": false,
                "boundStyle": {
                    "stroke": "#28282B",
                    "width": 2,
                    "opacity": 0.8,
                    "dash": [
                        2,
                        6
                    ]
                }
            },
            "mw": {
                "show": $('.celestialMilkyWay').hasClass('active__picker'),
                "style": {
                    "fill": "#28282B",
                    "opacity": "0.15"
                }
            },
            "lines": {
                "graticule": {
                    "show": $('.celestialGrid').hasClass('active__picker'),
                    "stroke": "#808080",
                    "width": 2.2,
                    "opacity": 0.6,
                    "lon": {
                        "pos": [],
                        "fill": "#808080",
                        "font": "10px 'Lucida Sans Unicode', Helvetica, Arial, sans-serif"
                    },
                    "lat": {
                        "pos": [],
                        "fill": "#808080",
                        "font": "10px 'Lucida Sans Unicode', Helvetica, Arial, sans-serif"
                    }
                }
            },
            "planets": {
                "show": $('.celestialMoon').hasClass('active__picker'),
                "which": ["ter", "lun"],
                "symbols": {
                    "lun": {
                        "symbol": "\u25CF",
                        "letter": "L",
                        "fill": "#D3D3D3",
                        "size": 40
                    }
                }
            }
        }
    Celestial.apply(config)
  }


  function changeStarAndConstellationToDarkColor(){
    var config = {
            "stars": {
                "show": true,
                "limit": 6,
                "colors": false,
                "style": {
                    "fill": "#ffffff",
                    "opacity": 1
                },
                "designation": false,
                "designationType": "desig",
                "designationStyle": {
                    "fill": "#ddddbb",
                    "font": "11px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif",
                    "align": "left",
                    "baseline": "top"
                },
                "designationLimit": 2.5,
                "propername": false,
                "propernameType": "name",
                "propernameStyle": {
                    "fill": "#ddddbb",
                    "font": "0px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif",
                    "align": "right",
                    "baseline": "bottom"
                },
                "propernameLimit": 1.5,
                "size": 12,
                "exponent": -0.29,
                "data": "stars.6.json"
            },
            "constellations": {
                "show": $('.celestialConstellation').hasClass('active__picker'),
                "names": $('.celestialConstellationNames').hasClass('active__picker'),
                "nameStyle": {
                    "fill": "#ffffff",
                    "align": "center",
                    "baseline": "middle",
                    "opacity": 0.8,
                    "font": [
                        "20px Open Sans, Arial, sans-serif",
                        "15px Open Sans, Arial, sans-serif",
                        "15px Open Sans, Arial, sans-serif"
                    ]
                },
                "lineStyle": {
                    "stroke": "#cccccc",
                    "width": 1,
                    "opacity": 0.75
                },
                "lines": true,
                "bounds": false,
                "boundStyle": {
                    "stroke": "#ccff00",
                    "width": 2,
                    "opacity": 0.8,
                    "dash": [
                        2,
                        6
                    ]
                }
            },
            "mw": {
                "show": $('.celestialMilkyWay').hasClass('active__picker'),
                "style": {
                    "fill": "#ffffff",
                    "opacity": "0.15"
                }
            },
            "lines": {
                "graticule": {
                    "show": $('.celestialGrid').hasClass('active__picker'),
                    "stroke": "#949494",
                    "width": 2.8,
                    "opacity": 0.7,
                    "lon": {
                        "pos": [],
                        "fill": "#eee",
                        "font": "10px 'Lucida Sans Unicode', Helvetica, Arial, sans-serif"
                    },
                    "lat": {
                        "pos": [],
                        "fill": "#eee",
                        "font": "10px 'Lucida Sans Unicode', Helvetica, Arial, sans-serif"
                    }
                }
            },
            "planets": {
                "show": $('.celestialMoon').hasClass('active__picker'),
                "which": ["ter", "lun"],
                "symbols": {
                    "lun": {
                        "symbol": "\u25CF",
                        "letter": "L",
                        "fill": "#ffffff",
                        "size": 40
                    }
                }
            }
        }

        Celestial.apply(config)
    }

    function changeTextToLightColor(map_color){
        $('.frame-container').css('color', '#000000')
        //$('.custom-frame.bg-new').css('background-color', map_color)


        $('.editor-color-53 .cust').css('fill', map_color)
        $('.editor-color-53 .cust').css('fill', map_color)
        $('.stBg').css('fill', map_color)
        $('.bor').css('fill','#000000')
        $('.st1').css('fill','#000000')
        $('.strokeCouple').css('stroke','#000000')
		if($('.style_picker .elem__picker.active__picker').index() == 1){
			$('.frame-container').css('color', '#ffffff')
		}
    }

    function changeTextToDarkColor(map_color){
        $('.frame-container').css('color', '#ffffff')
        //$('.custom-frame.bg-new').css('background-color', '#fff')
        //$('.custom-frame.bg-new').css('color', '#000')
        $('.editor-color-53 .cust').css('fill', map_color)
        //$('.custom-frame.bg-new').css('color', '#fff')

        $('.editor-color-53 .cust').css('fill', map_color)
        $('.stBg').css('fill', map_color)
        $('.bor').css('fill','#ffffff')
        $('.st1').css('fill','#ffffff')
        $('.strokeCouple').css('stroke','#ffffff')
		if($('.style_picker .elem__picker.active__picker').index() == 1){
			$('.frame-container').css('color', '#ffffff')
		}
    }

  
function lightOrDark(color, variant) {

    // Variables for red, green, blue values
    var r, g, b, hsp, m_color = color;
    
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {

        // If RGB --> store the red, green, blue values in separate variables
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        
        r = color[1];
        g = color[2];
        b = color[3];
    } 
    else {
        
        // If hex --> Convert it to RGB: http://gist.github.com/983661
        color = +("0x" + color.slice(1).replace( 
        color.length < 5 && /./g, '$&$&'));

        r = color >> 16;
        g = color >> 8 & 255;
        b = color & 255;
    }
    
    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(
    0.299 * (r * r) +
    0.587 * (g * g) +
    0.114 * (b * b)
    );

    // Using the HSP value, determine whether the color is light or dark
    if (hsp>127.5) {
        if(variant == 'map'){
            changeStarAndConstellationToLightColor()
            star_map_color_or = m_color;
        }else if(variant == 'background'){
            setTimeout(()=>{
                changeTextToLightColor(color)
                show_border()
            }, 200)
        }
        return 'light';
    } 
    else {
        if(variant == 'map'){
            changeStarAndConstellationToDarkColor()
			star_map_color_or = m_color;
        }else if(variant == 'background'){
            setTimeout(()=>{
                changeTextToDarkColor(color)
                show_border()
            }, 200)
        }
        return 'dark';
    }

    
}

  function changeBackgroundColor(){
	//Check White Background
	if(map_color_present == ''){
		if($('.bg_map_color_change .elem__picker.active__picker').hasClass('custom_color_picker')){
			var map_color = $('.bg_map_color_change .elem__picker #html5colorpicker').val()
		}else{
			var map_color = $('.grid__picker.bg_map_color_change .elem__picker.active__picker .image__circle.image__color').data('color')
		}
	}else{
		map_color = map_color_present
	}

		$('.custom_color_bg').css('background-color',map_color)

		// Determine actual background color being used
		var actual_bg_color;
		if($('.bg_color_change .elem__picker.active__picker').index() == 1){
			// White background selected
			actual_bg_color = '#ffffff';
			$('.custom-frame.bg-new').css('background-color', '#fff')
			$('.editor-color-53 .cust').css('fill', '#ffffff')
			$('.stBg').css('fill', '#ffffff')
		}else{
			// Colored background
			actual_bg_color = map_color;
			$('.custom-frame.bg-new').css('background-color', map_color)
			$('.editor-color-53 .cust').css('fill', map_color)
			$('.stBg').css('fill', map_color)
		}

		// Set text/border colors based on whether background is light or dark
		if(lightOrDark(actual_bg_color, 'none') == 'light'){
			$('.custom-frame.bg-new').css('color', '#000')
			$('.frame-container').css('color', '#000000')
			$('.bor').css('fill','#000000')
			$('.st1:not(.cust)').css('fill','#000000')
			$('.strokeCouple').css('stroke','#000000')
		}else{
			$('.custom-frame.bg-new').css('color', '#fff')
			$('.frame-container').css('color', '#ffffff')
			$('.bor').css('fill','#ffffff')
			$('.st1:not(.cust)').css('fill','#ffffff')
			$('.strokeCouple').css('stroke','#ffffff')
		}

		// Re-apply cust fill after st1 to ensure it's not overwritten
		$('.editor-color-53 .cust').css('fill', actual_bg_color)
		$('.stBg').css('fill', actual_bg_color)

		show_border()
  }

function lat_card(lat){
	var latitudeCardinal;
	var latitude = lat;
	if(lat >= 0){
	  latitudeCardinal = "N";
	}else{
	 latitudeCardinal = "S";
	 latitude = -1*lat;
	}

	$('#custom_lat_input input').val(latitude)
	$('#custom_lat_input select option[value="'+latitudeCardinal+'"]').prop('selected', true)
	return latitude + "˚ " + latitudeCardinal
  }
  
  function lng_card(lng){
	var longitudeCardinal;
	var longitude = lng;
	if(lng >= 0){
	  longitudeCardinal = "E";
	}else{
	  longitudeCardinal = "W";
	  longitude = -1*lng;
	}

	$('#custom_lng_input input').val(longitude)
   	$('#custom_lng_input select option[value="'+longitudeCardinal+'"]').prop('selected', true)
  	return longitude + "˚ " + longitudeCardinal
  }

  function changeLocation(lat, lng){
	Celestial.location([lat, lng])
	$('.custom-address #custom_lat_lng').html(lat_card(lat.toFixed(2))+", "+lng_card(lng.toFixed(2)))
    $('#custom_lat_long').val(lat_card(lat.toFixed(2))+", "+lng_card(lng.toFixed(2)))
  }

  function daytag(day){
    var daytag = "th";
    if(day == 1 || day == 21 || day == 31){
        daytag = "st";
    }else if(day == 2 || day == 22){
        daytag = "nd";
    }else if(day == 3 || day == 23){
        daytag = "rd";
    }else{
        daytag = "th";
    }
    return daytag;
  }

  function timetag(hrs){
    var timetag = "am";
    if(hrs > 12){
      timetag = "pm";
    }else if(hrs == 12){
      timetag = "pm";
    }else{
      timetag = "am"
    }
    return timetag;
  
  }
  
  $('#time_on').on('change', function(){
    changeDateTime()
  })

  function changeDateTime(){
	// Check if timepicker is initialized (has hours-dropdown inside)
	var $timePicker = $("#timePicker");
	if (!$timePicker.length || !$timePicker.find(".hours-dropdown").length) {
		return; // Timepicker not ready yet, skip
	}
	let timezone = Celestial.timezone()
	const element = $timePicker[0]
	const id = $timePicker.attr("id")
	let year = $('.bear-years').val()
	let month = $('.bear-months').val()
	let date = $('.bear-dates').val()
	var hours = $timePicker.find(".hours-dropdown")[0].value
	let minutes = $timePicker.find(".minutes-dropdown")[0].value;
	if($timePicker.find("#" + id + "MeridianPM")[0].checked){
		hours = 12 + parseInt(hours)
	}
	const d = new Date(year, month, date, hours, minutes);
	Celestial.date(d, timezone)

    var monthh = ['January','February','March','April','May','June','July','August','September','October','November','December'];

    if(!document.getElementById('time_on').checked){
        document.querySelector('input#mat-input-7').value = date+daytag(date)+" "+monthh[parseInt(month)]+" "+year;
    
        $('#custom_date').html(date+daytag(date)+" "+monthh[parseInt(month)]+" "+year)
      }else{
        hours_12 = hours
        if(hours > 12){
            hours_12 = hours - 12
        }
        document.querySelector('input#mat-input-7').value = date+daytag(date)+" "+monthh[parseInt(month)]+" "+year+" - "+hours_12+":"+minutes+" "+timetag(hours);
        $('#custom_date').html( date+daytag(date)+" "+monthh[parseInt(month)]+" "+year+" - "+hours_12+":"+minutes+" "+timetag(hours))
      }
  }


  var shapeName='Cerc';
  function change_shape(val){
   if(val.id == 'cb17'){
   shapeName = 'Cerc';
   $('.custom_iframe').html($('#abc_6').val())
   }else if(val.id == 'cb18'){
   shapeName = 'Fetita';
   $('.custom_iframe').html($('#abc_4').val())
   }else if(val.id == 'cb19'){
   shapeName = 'Baiat';
   $('.custom_iframe').html($('#abc_1').val())
   }else if(val.id == 'cb20'){
   shapeName = 'Stea';
   $('.custom_iframe').html($('#abc_3').val())
   }else if(val.id == 'cb21'){
   shapeName = 'Inima';
   $('.custom_iframe').html($('#abc_2').val())
   }else if(val.id == 'cb51'){
   shapeName = 'Cuplu';
   $('.custom_iframe').html($('#abc_7').val())
   }else if(val.id == 'cb52'){
   shapeName = 'Pisica';
   $('.custom_iframe').html($('#abc_8').val())
   }else if(val.id == 'cb53'){
   shapeName = 'Catel';
   $('.custom_iframe').html($('#abc_9').val())
   }else if(val.id == 'cb54'){
   shapeName = 'Compas';
   $('.custom_iframe').html($('#abc_10').val())
   }
   else{
   shapeName = 'Cerc';
   $('.custom_iframe').html($('#abc_6').val())
   }
   changeBackgroundColor()
  }

function initMapImpl() {
	var input = document.getElementById('address_form1');
	var autocomplete = new google.maps.places.Autocomplete(input);

	dates('option');
	months('option');
	var d = new Date();
	var year = d.getFullYear();
	years('option', year-70, year+10);
	$("#timePicker").timepicker({});

    $('#custom_address').keyup(function(){
        $('#custom_add').html($(this).val())
    })

    $('#mat-input-7').keyup(function(){
        $('#custom_date').html($(this).val())
    })

    $('#custom_lat_long').keyup(function(){
        $('#custom_lat_lng').html($(this).val())
    })

	$('div#print').css('min-height', $('.custom-frame').outerHeight()+20+'px')
	google.maps.event.addListener(autocomplete, 'place_changed', function () {
      $('.submit__form').css({
        "opacity": "1",
        "pointer-events": "auto"
      }).find('.custom_text').text($('.add_to_cart_text').val())
	  var place = autocomplete.getPlace();
      $('#custom_address').val(input.value)
      $('#custom_add').html(input.value)
	  changeLocation(place.geometry.location.lat(), place.geometry.location.lng())

	  //Set place location to input
	  //document.getElementById('textLocation').value = document.getElementById('address_form1').value

	  let lat_1 = (place.geometry.location.lat()).toFixed(2);
	  let lng_1 = (place.geometry.location.lng()).toFixed(2);

	  let custom_lat = lat_card(lat_1)
	  let custom_long = lng_card(lng_1)
		  
	});
  }
  

  $('#custom_lat_input input, #custom_lat_input select, #custom_lng_input input, #custom_lng_input select').on('change', function(){
	var custom_lat = parseFloat($('#custom_lat_input input').val())
	var custom_lng = parseFloat($('#custom_lng_input input').val())

	if($('#custom_lat_input select').val() == 'S'){
		custom_lat = -1 * custom_lat
	}
	if($('#custom_lng_input select').val() == 'W'){
		custom_lng = -1 * custom_lng
	}

	changeLocation(custom_lat, custom_lng)

  })


 $("#timePicker").timepicker({
	onChange: function (value) {
		changeDateTime()
	}
 });

 $('.row__date--element select').on('change', function(){
	changeDateTime()
 })

 $('#textTitle').on('keyup', function(){
	$('#skyMap').html($(this).val())
	twemoji.parse(document.getElementById('skyMap'),
	{ base: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/' })
 })

 $('#textMessage').on('input', function(e) {
	formatTextAsRequired()
  })


  var lines = 5;
  var linesUsed = $('#messageRows');

  $('#textMessage').keydown(function(e) {

	  newLines = $(this).val().split("\n").length;
	linesUsed.text('Rand: '+newLines+' / '+lines);

	  if(e.keyCode == 13 && newLines >= lines) {
		  linesUsed.css('color', 'red');
		  return false;
	  }
	  else {
		  linesUsed.css('color', '');
	  }
  });


// $("#textMessage").bind("paste", function(e){
// 	handlePaste()
// } );

$('.checkChangeElement .elem__picker').on('click', function(){
	setTimeout(()=>{
		checkElementsChange()
	},50)
})


$('.bg_color_change .elem__picker, .bg_map_color_change .elem__picker').on('click', function(){
	setTimeout(()=>{
		map_color_present = ""
		changeBackgroundColor()
	},50)
})

$('#html5colorpicker').on('change', function(){
	changeBackgroundColor()
})

$('.star_map_color_change .elem__picker').on('click', function(){
	setTimeout(()=>{
		changeStarMapColor()
	},50)
})

$('#html5colorpickerstarmap').on('change', function(){
	changeStarMapColor()
})





$('.custom_border .elem__picker').on('click', function(){
	setTimeout(()=>{
		show_border()
	},50)
})

$('.style_picker .elem__picker').on('click', function(){
	setTimeout(()=>{
		change_style()
	},50)
})

$('.show_on_bg .elem__picker').on('click', function(){
	setTimeout(()=>{
		change_background_image()
	},50)
})

$('.font_change_message .elem__picker').on('click', function(){
	setTimeout(()=>{
		change_font_message()
	},50)
})


$('.font_change_details .elem__picker').on('click', function(){
	setTimeout(()=>{
		change_font_details()
	},50)
})


$('#image_code').on('click', function(){
	if($(this).prop('checked')){
		$('img#bg-img-new').prop('src',image_upload_file).show()
		$('.custom-textarea').addClass('mt-6v')
	}else{
		$('img#bg-img-new').prop('src',preview_thumb_upload).hide()
		$('.custom-textarea').removeClass('mt-6v')
	}
})

$('#qrCodeSlide').on('click', function(){
	if($(this).prop('checked')){
		$('#qrcode').fadeIn();
        $('div#qrcode img').prop('src',qr_url);
	}else{
		$('#qrcode').fadeOut();
        $('div#qrcode img').prop('src','');
	}
})





// var qrcode = new QRCode(document.getElementById("qrcode"), {
// 	width : 1000,
// 	height : 1000,
// 	colorDark : '#000',
// 	colorLight : '#fff',
// 	correctLevel : QRCode.CorrectLevel.H
// });

$('#qr-input').on('change', function(e){
    e.preventDefault();
	var elText = document.getElementById("qr-input");

    
	if (elText.value) {
        fetch(proxy_loc+'create-qr/?data='+elText.value+'/&id='+order_id)
        .then(response => response.json())
        .then(data => {
            console.log(data);
            document.getElementById("qrcode").innerHTML = `<img src="${data.img_name}" />`;
            qr_url = data.img_name
        })
    }
	// qrcode.makeCode(elText.value);
	// console.log(qrcode)
})

// call_run = 0
// prev_val = 0
// var myInterval;
// myInterval = setInterval(myTimer, 1000);
// Celestial.addCallback(function(e){
// 	call_run = call_run+1
	
// 	console.log(call_run)
	
// 	prev_val = call_run
// })

// function myTimer() {
// 	if(call_run == prev_val){
// 		console.log('Done')
// 		//myStopFunction() 
// 	}
// }

// function myStopFunction() {
//   clearInterval(myInterval);
// }


//Celestial.exportSVG( function(data) { console.log(data) })

$('.submit__form').on('click', function(e){
    e.preventDefault();
    submit_form('')
})

$('.btn-send-email').on('click', function(e){
    e.preventDefault();
    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if ($('.input-email').val().match(validRegex)) {
      submit_form('?send_email=true')
      $('.ant-modal.popup-send-email .close-btn').click()
    }else{
      alert('Enter a valid email.')
    }
    
})

// Register initMap with the stub defined in theme.liquid
// If Google Maps already loaded, call initMapImpl immediately
if (typeof initMapReal !== 'undefined') {
  initMapReal = initMapImpl;
  if (typeof initMapReady !== 'undefined' && initMapReady) {
    initMapImpl();
  }
} else {
  // Fallback: define initMap directly if stub wasn't loaded
  window.initMap = initMapImpl;
}

function submit_form(params){
  $('#cover-spin').show()
    Celestial.exportSVG( function(star_map_svg) { 
        var mynewmssg = document.querySelector('.custom-textarea').innerHTML;
        
        if($('.custom-textarea br').length == 0){
            mynewmssg = "<br><br>"+document.querySelector('.custom-textarea').innerHTML+"<br><br><br>";
        }else if($('.custom-textarea br').length <= 1){
            mynewmssg = "<br><br>"+document.querySelector('.custom-textarea').innerHTML+"<br><br>";
        }else if($('.custom-textarea br').length <= 2){
            mynewmssg = "<br>"+document.querySelector('.custom-textarea').innerHTML+"<br><br>";
        }else if($('.custom-textarea br').length <= 3){
            mynewmssg = "<br>"+document.querySelector('.custom-textarea').innerHTML+"<br>";
        }else if($('.custom-textarea br').length <= 4){
            mynewmssg = document.querySelector('.custom-textarea').innerHTML+"<br>";
        }

        var bg_img = document.querySelector('.custom-frame'),
        style = bg_img.currentStyle || window.getComputedStyle(bg_img, false),
        bg_image_url = style.backgroundImage.slice(4, -1).replace(/"/g, "");

        

        let model = $('.style_picker .active__picker .info__picker').text().trim(),
        email = $('.input-email').val()
        address = $('#custom_address').val(),
        date = $('.bear-dates').val()+" "+$('.bear-months').val()+" "+$('.bear-years').val(),
        time = $('.hours-dropdown').val()+" "+$('.minutes-dropdown').val()+" "+$('[name="timePickerMeridian"]:checked+label').html(),
        date_time = $('#mat-input-7').val(),
        custom_image_url = ($('img#bg-img-new').prop('src').includes(preview_thumb_upload) || $('img#bg-img-new').prop('src').includes(window.location.host))? "": $('img#bg-img-new').prop('src'),
        qr_text = $('#qr-input').val(),
        qr_url = $('#qrcode img').prop('src')?$('#qrcode img').prop('src'):"",
        title = $('input#textTitle').val(),
		custom_location = $('#address_form1').val().trim(),
        message = mynewmssg,
        message_preview = $('#textMessage').val(),
        lat = $('#custom_lat_input input').val()+" "+$('#custom_lat_input select').val(),
        long = $('#custom_lng_input input').val()+" "+$('#custom_lng_input select').val(),
        coordinates = $('#custom_lat_long').val(),
        constellations = $('.celestialConstellation').hasClass('active__picker'),
        grid = $('.celestialGrid').hasClass('active__picker'),
        milkyway = $('.celestialMilkyWay').hasClass('active__picker'),
        moon = $('.celestialMoon').hasClass('active__picker'),
        constellationNames = $('.celestialConstellationNames').hasClass('active__picker'),

        star_map_elements = "constellations:"+constellations+", grid:"+grid+", milkyway:"+milkyway+", moon:"+moon+", constellationNames:"+constellationNames,

        shape = $('.shape_change_1 .elem__picker.active__picker').data('shape'),
		shape_svg = $('.custom_iframe').html().trim(),

        background_color = $('.custom-frame').css('background-color'),

        text_color = $('.custom-frame .frame-container').css('color'),

        star_map_color = star_map_color_or,

        border = $('.custom_border .elem__picker.active__picker').index() == 1? true:false,

        message_font = $('.font_change_message .elem__picker.active__picker .image__circle p').css('font-family'),
        
        details_font = $('.font_change_details .elem__picker.active__picker .image__circle p').css('font-family');

        // if($('[name="background-img"]:checked').data('id') == 'Fundal-2'){
        //   bg_image_url = `https://skymapro-space.fra1.digitaloceanspaces.com/skymapro-space/${$('[data-state="'+$('.state_1.active__picker').data("state")+'"].state_2 .active__picker p').text().trim().split(' ')[1]}%20-%20bg.png`;
        // }

        if(bg_image_url.includes('Template_1.jpg')){
          bg_image_url = '';
          background_color = '#000'
        }

        (async () => {
            const rawResponse = await fetch(proxy_loc+'star-map-data/'+params, {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
                body: JSON.stringify({
                    "size":    $('[data-state="'+$('.state_1.active__picker').data("state")+'"].state_2 .active__picker p').text().trim().split('x')[1]?$('[data-state="'+$('.state_1.active__picker').data("state")+'"].state_2 .active__picker p').text().trim().replace('cm',''):"13x18", 
                    "email": email,
                    "order": order_id,
                    "model": model,
					"location": custom_location,
                    "address": address,
                    "date": date,
                    "time": time,
                    "date_time": date_time,
                    "custom_image_url": custom_image_url,
                    "qr_text": qr_text,
                    "qr_url": qr_url,
                    "bg_image_url": bg_image_url,
                    "title": title,
                    "message": message,
                    "message_preview": message_preview,
                    "lat": lat,
                    "long": long,
                    "coordinates": coordinates,
                    "star_map_elements": star_map_elements,
                    "shape": shape,
					"shape_svg": shape_svg,
                    "background_color": background_color,
                    "text_color": text_color,
                    "star_map_color": star_map_color,
                    "border": border,
                    "message_font": message_font,
                    "details_font": details_font,
                    "svg_image": star_map_svg.replaceAll('/*&lt;![CDATA[*/','')
                })
            });
            const content = await rawResponse.json();


          
console.log(params)
 console.log(params == '')         
  if(params == ''){
      var sel_type = $('.state_1.active__picker').data("state").split('__')[0].toUpperCase()
      var sel_frame = ''
      if($('.state_1.active__picker').data("state").split('__')[0] == 'Poster' && $('[data-state="'+$('.state_1.active__picker').data("state")+'"].state_3 .active__picker p').text().trim() == 'Fara rama'){
      	sel_type = 'POSTER'
      }else if($('.state_1.active__picker').data("state").split('__')[0] == 'Poster' && $('[data-state="'+$('.state_1.active__picker').data("state")+'"].state_3 .active__picker p').text().trim() != 'Fara rama'){
      	sel_type = 'POSTER';
          sel_frame =  $('[data-state="'+$('.state_1.active__picker').data("state")+'"].state_3 .active__picker p').text().trim();
      }else if($('.state_1.active__picker').data("state").split('__')[0] == 'Canvas'){
      	sel_type = 'TABLOU CANVAS'
      }else if($('.state_1.active__picker').data("state").split('__')[0] == 'Sky Light'){
      	sel_type = 'SKY LIGHT'
      }
  
      if($('.state_1.active__picker').data("state").split('__')[0] == 'Tablou'){
            sel_type = sel_type+" STICLA"
        	sel_frame = 'Rama '+$('[data-state="'+$('.state_1.active__picker').data("state")+'"].state_3 .active__picker p').text().trim()
      }
  
      var selected_size = 'Marimea '+$('[data-state="'+$('.state_1.active__picker').data("state")+'"].state_2 .active__picker p').text().trim();
  
            
            let formData = {
             'items': [{
              'id': $('#var_id').val(),
              'quantity': 1,
               "properties" : {
                  "OrderID": order_id,
                  "Data & Ora": date_time,
                  "Elemente": star_map_elements,
                  "Locatie": address,
                  "Mesaj": message_preview,
                   "Titlu": title,
                   "_print_url": "https://luxcanva.karangoyal.cc/api/download/?orderId="+order_id+"&version="+Date.now(),
                   "_selected_type": sel_type,
                   "_selected_size": selected_size,
                   "_selected_frame": sel_frame
                }
              }]
            };

    if(cart_order_id_present.includes(order_id)){
        let formData1 = {
  'id': cart_order_id_present_id[cart_order_id_present.indexOf(order_id)],
  'quantity': 0
};
      fetch('/' + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData1)
      })
      .then(response => {
        return response.json();
      }).then(response => {
        fetch('/' + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            return response.json();
          })
          .then(response => {
           
            setTimeout(()=>{
               $('#cover-spin').hide()
             window.location.href = '/cart'
            },6000)
              console.log(response);
          })
          .catch((error) => {
            $('#cover-spin').hide()
            console.error('Error:', error);
          });
      })
      .catch((error) => {
        console.error('Error:', error);
        $('#cover-spin').hide()
        alert('Please try again some error occured.')
        
      });
    }else{
            
          fetch('/' + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            return response.json();
          })
          .then(response => {
             setTimeout(()=>{
              $('#cover-spin').hide()
             window.location.href = '/cart'
             },6000)
              console.log(response);
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }
          }
            console.log(content);
          })();
    })
    
}